<template>
  <ViewContainer :px="6">
    <v-layout column fill-height justify-space-between>
      <v-flex>
        <section class="page-title-box mb-10">
          <h1>
            상담원과 통화 후<br />
            바로 이용할 수 있어요.
          </h1>
          <p>1811-2708로 전화가 갈 거예요.</p>
        </section>

        <section class="text-center" :class="{ 'pt-7': $vuetify.breakpoint.height >= 700 }">
          <img src="@/assets/images/signup/call.svg" />
        </section>
      </v-flex>

      <section class="page-footer-column">
        <BasicButton block :to="{ name: 'main' }" id="btn__CjdbH534z0mnuaII9w4GaQ==">
          통화를 완료했어요.
        </BasicButton>
      </section>
    </v-layout>
  </ViewContainer>
</template>

<script>
export default {}
</script>
